var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CDropdown',{attrs:{"toggler-text":_vm.orderOption,"placement":"right-start","addTogglerClasses":"customDropDownColor"}},[_c('CDropdownItem',{on:{"click":function($event){_vm.orderOption = 'A-Z'}}},[_vm._v("A-Z")]),_c('CDropdownItem',{on:{"click":function($event){_vm.orderOption = 'Z-A'}}},[_vm._v("Z-A")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }